"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var effects_1 = require("redux-saga/effects");
var Immutable = require("seamless-immutable");
var typescript_fsa_1 = require("typescript-fsa");
var typescript_fsa_reducers_1 = require("typescript-fsa-reducers");
var functions = require("../infra/functions");
var media_1 = require("../infra/media");
var message = require("./message");
var utils_1 = require("./utils");
var actionCreator = typescript_fsa_1.default("ENVIRONMENT");
var setIsSmallWindow = actionCreator("SET_IS_SMALL_WINDOW");
var setPointerAvailable = actionCreator("SET_POINTER_AVAILABLE");
var setTouchable = actionCreator("SET_TOUCHABLE");
var getCountry = actionCreator.async("GET_COUNTRY");
exports.actionCreators = {
    getCountry: function () { return getCountry.started(null); },
};
exports.initialState = Immutable({
    country: null,
    isSmallWindow: media_1.isSmallWindow,
    pointerAvailable: media_1.pointerAvailable,
    touchable: media_1.touchable,
});
exports.reducer = typescript_fsa_reducers_1.reducerWithInitialState(exports.initialState)
    .case(getCountry.done, function (state, _a) {
    var result = _a.result;
    return state.merge({ country: result });
})
    .case(setIsSmallWindow, function (state, isSmallWindow) { return state.merge({ isSmallWindow: isSmallWindow }); })
    .case(setPointerAvailable, function (state, pointerAvailable) { return state.merge({ pointerAvailable: pointerAvailable }); })
    .case(setTouchable, function (state, touchable) { return state.merge({ touchable: touchable }); });
exports.sagas = [
    utils_1.takeEvery(getCountry.started, function _() {
        var _a, _b, _c, _d, error_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 3, , 5]);
                    _a = effects_1.put;
                    _c = (_b = getCountry).done;
                    _d = {
                        params: null
                    };
                    return [4 /*yield*/, effects_1.call(functions.call, "country", { cache: false })];
                case 1: return [4 /*yield*/, _a.apply(void 0, [_c.apply(_b, [(_d.result = _e.sent(),
                                _d)])])];
                case 2:
                    _e.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _e.sent();
                    return [4 /*yield*/, effects_1.put(message.actionCreators.sendMessage("Couldn't connect to the Internet.", { error: true }))];
                case 4:
                    _e.sent();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }),
];
function storeInitializer(store) {
    media_1.onWindowSizeChange(function (isSmallWindow) { return store.dispatch(setIsSmallWindow(isSmallWindow)); });
    media_1.onTouchabilityChange(function (touchable) { return store.dispatch(setTouchable(touchable)); });
    media_1.onPointerChange(function (pointerAvailable) {
        return store.dispatch(setPointerAvailable(pointerAvailable));
    });
}
exports.storeInitializer = storeInitializer;



//////////////////
// WEBPACK FOOTER
// ./src/redux/environment.ts
// module id = 257
// module chunks = 0